/**
 * Format a date to MM-DD-YYYY format
 */
export const formatDate = (date: string | Date | undefined): string => {
	if (!date) return 'N/A'

	try {
		return new Date(date)
			.toLocaleDateString('en-US', {
				month: '2-digit',
				day: '2-digit',
				year: 'numeric',
			})
			.replace(/\//g, '-')
	} catch {
		return 'Invalid date'
	}
}

export const formatDateTime = (date: string | Date | undefined): string => {
	if (!date) return 'N/A'

	try {
		return new Date(date)
			.toLocaleString('en-US', {
				month: '2-digit',
				day: '2-digit',
				year: 'numeric',
				hour: '2-digit',
				minute: '2-digit',
				hour12: false,
			})
			.replace(/\//g, '-')
			.replace(',', '')
	} catch {
		return 'Invalid date'
	}
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function formatValue(value: any): any {
	if (typeof value === 'boolean') {
		return value ? 'Active' : 'Inactive'
	}

	if (!value) return '-'

	if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value)) {
		const date = new Date(value)
		return formatDateTime(date)
	}

	if (typeof value === 'number') {
		return value.toLocaleString()
	}

	if (Array.isArray(value)) {
		return value.map(formatValue).join(', ')
	}

	if (typeof value === 'object' && value !== null) {
		return Object.fromEntries(Object.entries(value).map(([key, val]) => [key, formatValue(val)]))
	}

	return value
}

export const pluralize = (value: number, singular: string, plural: string): string => {
	return value === 1 ? singular : plural
}
